import { Route, Routes } from 'react-router-dom';
import { Dashboard } from './routes/Dashboard/Dashboard';
import ReportDetails from './routes/ReportDetails/ReportDetails';
import RaportDetails from './routes/ReportDetails/raport-details';
import { lazy, Suspense } from 'react';
import { Layout } from './components/Layout/Layout';
import { SidebarAccordion } from './components/SidebarAccordion';
import { VinStoryReport } from './routes/VinStoryReport/VinStoryReport';
import { RaportHSP } from './routes/ReportHSP/RaportHSP';
import { NotFound } from './routes/NotFound';
import RaportDetailsTemp from './routes/ReportDetails/raport-details-temp';
import ReportAccess from './routes/ReportAccess';

// Leniwe ładowanie komponentu MockDevTools tylko w trybie deweloperskim
const MockDevTools = lazy(() =>
  import.meta.env.DEV
    ? import('./mocks/DevTools')
    : Promise.resolve({ default: () => null }),
);

function App() {
  return (
    <div>
      <Routes>
        <Route
          path="/"
          element={
            <Layout title="Strona główna">
              <Dashboard />
            </Layout>
          }
        />
        <Route
          path="/zamowienie/:id"
          element={<ReportDetails />}
        />
        <Route
          path="/vin-raport"
          element={
            <Layout title="Vin raport">
              <VinStoryReport />
            </Layout>
          }
        />
        <Route
          path="/hsp-raport"
          element={
            <Layout
              title="HSP raport"
              hasSidebar
              logo={<>test</>}
              navbarContent={<nav className="h-[100px]">navnar testt</nav>}
              sidebarContent={
                <SidebarAccordion
                  items={[
                    {
                      label: 'Kluczowe wskaźniki',
                      value: 'podstawowe-informacje',
                      elementId: 'podstawowe-informacje',
                      icon: 'paper',
                      active: true,
                    },
                    {
                      label: 'Rekomendacje i ostrzeżenia',
                      value: 'rekomendacje-ostrzezenia',
                      elementId: 'rekomendacje-ostrzezenia',
                      icon: 'warning',
                    },
                    {
                      label: 'Dane identyfikacyjne',
                      value: 'dane-identyfikacyjne',
                      elementId: 'dane-identyfikacyjne',
                      icon: 'i',
                    },
                    {
                      label: 'Oś czasu pojazdu',
                      value: 'os-czasu',
                      elementId: 'os-czasu',
                      icon: 'fish-swimming',
                    },
                    {
                      label: 'Wykres przebiegów',
                      value: 'historia-przebiegu',
                      elementId: 'historia-przebiegu',
                      icon: 'chart-analytics',
                    },
                    {
                      label: 'Historia szkód pojazdu',
                      value: 'historia-szkod',
                      elementId: 'historia-szkod',
                      icon: 'car-accident',
                    },
                    {
                      label: 'Status prawny',
                      value: 'status-prawny',
                      elementId: 'status-prawny',
                      icon: 'libra',
                    },
                    {
                      label: 'Wycena wartości pojazdu',
                      value: 'wycena',
                      elementId: 'wycena',
                      icon: 'ruler-measure',
                    },
                    {
                      label: 'Wyposażenie pojazdu',
                      value: 'wyposazenie-pojazdu',
                      elementId: 'wyposazenie-pojazdu',
                      icon: 'trophy',
                      items: [
                        {
                          label: 'Wyposażenie standardowe',
                          elementId: 'wyposazenie-standardowe',
                          icon: 'handshake',
                        },
                        {
                          label: 'Wyposażenie opcjonalne',
                          elementId: 'wyposazenie-opcjonalne',
                          icon: 'plus-circle',
                        },
                      ],
                    },
                    {
                      label: 'Dane techniczne',
                      value: 'dane-techniczne',
                      elementId: 'dane-techniczne',
                      defaultOpen: true,
                      icon: 'car',
                      items: [
                        {
                          label: 'Nadwozie',
                          elementId: 'nadwozie',
                          icon: 'car',
                        },
                        {
                          label: 'Wymiary i masa',
                          elementId: 'wymiary-i-masa',
                          icon: 'person-shirt',
                        },
                        {
                          label: 'Koła i zawieszenie',
                          elementId: 'kola-i-zawieszenie',
                          icon: 'network-connection',
                        },
                        {
                          label: 'Zużycie paliwa i emisje',
                          elementId: 'zuzycie-paliwa-i-emisje',
                          icon: 'gas',
                        },
                      ],
                    },
                    {
                      label: 'Galeria zdjęć',
                      value: 'galeria-zdjec',
                      elementId: 'galeria-zdjec',
                      icon: 'grid-squares',
                    },
                  ]}
                />
              }
            >
              <RaportHSP />
            </Layout>
          }
        />
        <Route
          path="/raporty-temp/:id"
          element={
            <RaportDetails />
          }
        />
        <Route
          path="/raporty/:id"
          element={
            <RaportDetailsTemp />
          }
        />
        <Route
          path="/report-access"
          element={<ReportAccess />}
        />
        <Route
          path="/report-access/:linkId"
          element={<ReportAccess />}
        />
        <Route
          path="*"
          element={
            <Layout title="Nie znaleziono strony">
              <NotFound />
            </Layout>
          }
        />
      </Routes>

      {/* Komponent do przełączania mockowania w trybie deweloperskim
      <Suspense fallback={null}>
        <MockDevTools />
      </Suspense> */}
    </div>
  );
}

export default App;
